import { useEffect, useState } from "react";
import { api, euro, dataOra } from "@/lib/api";
import { Spinner } from "@/components/Layout";

const Stat = ({ label, value, id }) => (
  <div className="card">
    <p className="caption">{label}</p>
    <p className="font-display text-3xl mt-2" data-testid={id}>{value}</p>
  </div>
);

export function Vendite() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/operatore/vendite").then((r) => setD(r.data));
  }, []);
  if (!d) return <Spinner />;
  return (
    <div className="space-y-6">
      <div className="grid sm:grid-cols-3 gap-4">
        <Stat label="Venduto lordo" value={euro(d.totale_lordo_cent)} id="vendite-lordo" />
        <Stat label="Commissioni piattaforma" value={euro(d.commissioni_cent)} id="vendite-commissioni" />
        <Stat label="Netto" value={euro(d.netto_cent)} id="vendite-netto" />
      </div>
      <div className="card overflow-x-auto">
        <table className="tbl" data-testid="vendite-table">
          <thead><tr><th>Data</th><th>Acquirente</th><th>Quantità</th><th>Taglio</th><th>Totale</th><th>Regalo</th></tr></thead>
          <tbody>
            {d.ordini.map((o) => (
              <tr key={o.id}><td>{dataOra(o.pagato_il)}</td><td>{o.acquirente_nome}</td><td>{o.quantita}</td><td>{euro(o.importo_unit_cent)}</td><td>{euro(o.totale_cent)}</td><td>{o.regalo ? `Sì — ${o.destinatario_nome}` : "No"}</td></tr>
            ))}
            {!d.ordini.length && <tr><td colSpan={6} className="text-center text-[#786E65]">Nessuna vendita ancora</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const TIPI = { emissione: "Emissione", riscatto: "Riscatto", rimborso: "Rimborso" };

export function Movimenti() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/operatore/movimenti").then((r) => setD(r.data));
  }, []);
  if (!d) return <Spinner />;
  const tot = (k) => d.per_stato.reduce((s, x) => s + x[k], 0);
  const attive = d.per_stato.find((x) => x.id === "attiva");
  return (
    <div className="space-y-6">
      <div className="grid sm:grid-cols-3 gap-4">
        <Stat label="Totale emesso" value={euro(tot("emesso"))} id="mov-emesso" />
        <Stat label="Saldo residuo da riscattare" value={euro(attive?.saldo || 0)} id="mov-residuo" />
        <Stat label="Gift card attive" value={attive?.n || 0} id="mov-attive" />
      </div>
      <div className="card overflow-x-auto">
        <table className="tbl" data-testid="movimenti-table">
          <thead><tr><th>Data</th><th>Gift card</th><th>Tipo</th><th>Importo</th><th>Saldo dopo</th></tr></thead>
          <tbody>
            {d.movimenti.map((m) => (
              <tr key={m.id}><td>{dataOra(m.created_at)}</td><td className="font-code">{m.ultime4 ? `…${m.ultime4}` : "in consegna"}</td><td>{TIPI[m.tipo]}</td>
                <td className={m.importo_cent < 0 ? "text-red-700" : "text-emerald-700"}>{euro(m.importo_cent)}</td><td>{euro(m.saldo_dopo_cent)}</td></tr>
            ))}
            {!d.movimenti.length && <tr><td colSpan={5} className="text-center text-[#786E65]">Nessun movimento</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
